import { type MentionDescription } from '@atlaskit/mention';
import { SmartMentionResource } from '@atlassian/smart-mention-resource';

import { addSelectedMention } from '@canvas/api-mentions/mentions-state';
import { currentSiteData } from '@canvas/canvas-state/site-data';

class MentionProvider extends SmartMentionResource {
  recordMentionSelection(mention: MentionDescription) {
    const selectedMention = {
      id: mention.id,
      avatarUrl: mention.avatarUrl ?? '',
    };

    addSelectedMention(selectedMention);
  }
}

let mentionProvider: Promise<SmartMentionResource>;
export const getMentionProvider = (accountId?: string, cloudId?: string) => {
  if (mentionProvider) {
    return mentionProvider;
  }

  mentionProvider = Promise.resolve(
    new MentionProvider({
      productKey: 'confluence',
      shouldHighlightMention: (mention) => mention.id === accountId,
      siteId: cloudId ?? currentSiteData.siteId ?? '',
      includeTeams: true,
      includeUsers: true,
    })
  );
};
